(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["apap-redirect"] && !Shopify.designMode) return;
  try {
    class ApapRedirect extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url) return;

    const delaySeconds = Number(this.dataset.delay || 0);
    const delayMs = Number.isFinite(delaySeconds) ? Math.max(0, delaySeconds) * 1000 : 0;
    const go = () => {
      window.location.replace(url);
    };

    if (delayMs > 0) {
      this._timer = window.setTimeout(go, delayMs);
      return;
    }

    go();
  }

  disconnectedCallback() {
    if (this._timer) {
      window.clearTimeout(this._timer);
    }
  }
}

if (!customElements.get('apap-redirect')) {
  customElements.define('apap-redirect', ApapRedirect);
}
  } catch(e) { console.error(e); }
})();

})();
